import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { useAuth } from './AuthContext';

export const TeamsMoneyFunctions=({ pathName })=>{
  const { name, email, uniqueUserId } = useAuth();
  const isAuthenticated = !!(name && email);
  const navigate = useNavigate();
  const routerLocation = useLocation();

  function loadPosts() {
     var headers = {
         "Accept": "application/json",
         "x-api-key": process.env.REACT_APP_API_POSTS_KEY
     };

     var apiEndpoint =process.env.REACT_APP_API_POSTS_INVOKE_URL;
     var posts = [];

     $.ajax({
       type: "GET",
         url: apiEndpoint,
         headers: headers,
         data: "",
         contentType: "application/json",
         success: function(response) {
             if(response){
           var data = response.customMessage.result.data;}

           try {
             posts = JSON.parse(data);
           } catch (e) {
             console.error("Error parsing JSON:", e);
             return;
           }

           displayPostsWithVotes(posts);
         },
         error: function (error) {
             console.error("API error:", error);
             alert("Error calling the Posts API. Please try again later.");
         },
         complete: function (response) {
             response = {
                 statusCode: 200,
                 headers: {
                     'Access-Control-Allow-Origin': '*',
                     'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
                     'Access-Control-Allow-Methods': 'DELETE,GET,HEAD,OPTIONS,PATCH,POST,PUT',
                 },
             };
         }
     });
  }
  function displayPostsWithVotes(posts) {
   const postsContainer = $("#posts-container");
   postsContainer.empty();
   posts.forEach(post => {
       const postHTML = `
           <div class="post">
               <h6 className="col-md-6">${post.Title}</h6>
               <p>${post.Content}</p>
               <p><h8>Posted by: ${post.UserName}.&nbsp;&nbsp;${formatTimestamp(post.Timestamp)}</h9></p>
               <div class="votes">
                   <div class="upvote-button">
                       <span>${post.Upvotes}&nbsp;<img src="images/upvotes.png" alt="Upvote" upv-data-postid="${post.PostID}"></span>
                   </div>
                   <div class="downvote-button">
                       <span>${post.Downvotes}&nbsp;<img src="images/downvotes.png" alt="Downvote" downv-data-postid="${post.PostID}"></span>
                   </div>
               </div>
               <div>&nbsp;</div>
               <div style="padding-left: 20px;"><h6 className="col-md-6">Comments:</h6></div>
               <div className="col-md-6" style="padding-left: 20px;" id="comments-${post.PostID}">
                 ${post.Comments.length > 0 ? displayComments(post.Comments) : "No comments yet."}
               </div>
               <p></p>
               <p><button class="btn btn-navy mx-auto" style={{ backgroundColor: '#4CAF50' }} comm-data-postid="${post.PostID}">Add Comment</button></p>
           </div>
       `;
       postsContainer.append(postHTML);

       const commentButton = $(`[comm-data-postid="${post.PostID}"]`);
       commentButton.click(() => openCommentModal(post.PostID));

       const upvButton = $(`[upv-data-postid="${post.PostID}"]`);
       upvButton.click(() => upvotePost(post.PostID));

       const downvButton = $(`[downv-data-postid="${post.PostID}"]`);
       downvButton.click(() => downvotePost(post.PostID));
   });
  }
  function displayComments(comments) {
   let commentsHTML = "";
   comments.forEach(comment => {
     commentsHTML += `
       <div class="comment">
         <p><h9 className="col-md-6">${comment.username}.&nbsp;&nbsp;${formatTimestamp(comment.timestamp)}</h9></p>
         <p className="col-md-6">${comment.comment}</p>
       </div>
     `;
   });
   return commentsHTML;
  }
  function formatTimestamp(timestamp) {
   const date = new Date(timestamp * 1000);
   const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
   return date.toLocaleString('en-US', options);
  }

  function openCommentModal(postId) {
   const modal = $("#commentModal");
   modal.css("display", "block");
   const commentInput = $("#commentInput");
   const addCommentButton = $("#addCommentButton");

   addCommentButton.click(() => {
     if (!isAuthenticated) {
       alert("You must be signed in to add a comment. Please sign in or sign up.");
       // Redirect to the login page using navigate (React Router v6)
       navigate("/login", { state: { from: pathName } });
     } else {
       const commentVal = commentInput.val();
       if (commentVal) {
         var headers = {
             "Accept": "application/json",
             "x-api-key": process.env.REACT_APP_API_POSTS_KEY
         };

         var apiEndpoint = `${process.env.REACT_APP_API_POSTS_INVOKE_URL}/${postId}/createcomment`;

         $.ajax({
             url: apiEndpoint,
             type: 'PUT',
             headers: headers,
             contentType: "application/json",
             data: JSON.stringify({ comment: commentVal,
             uniqueuserid: uniqueUserId,
             username: name,
             useremail: email}),
             success: function (response) {
                 alert('Added comment successfully');
                 loadPosts();
             },
             error: function (error) {
                 alert('Failed to add comment');
             }
           });

           addCommentButton.prop("disabled", true);
           closeCommentModal();
       }
     }
   });

   const closeButton = $(".close");
   closeButton.click(closeCommentModal);
  }

  function closeCommentModal() {
   const modal = $("#commentModal");
   const commentInput = $("#commentInput");
   const addCommentButton = $("#addCommentButton");

   commentInput.val("");
   addCommentButton.prop("disabled", false);
   modal.css("display", "none");
  }

  function upvotePost(postId) {
     var headers = {
         "Accept": "application/json",
         "x-api-key": process.env.REACT_APP_API_POSTS_KEY
     };

     var apiEndpoint = `${process.env.REACT_APP_API_POSTS_INVOKE_URL}/${postId}/upvote`;

     $.ajax({
         url: apiEndpoint,
         type: 'PUT',
         headers: headers,
         contentType: "application/json",
         data: JSON.stringify({ up_votes: "True" }),
         success: function (response) {
             loadPosts();
         },
         error: function (error) {
             alert('Failed to upvote');
         }
     });
  }

  function downvotePost(postId) {
     var headers = {
         "Accept": "application/json",
         "x-api-key": process.env.REACT_APP_API_POSTS_KEY
     };

     var apiEndpoint = `${process.env.REACT_APP_API_POSTS_INVOKE_URL}/${postId}/downvote`;

     $.ajax({
         url: apiEndpoint,
         type: 'PUT',
         headers: headers,
         contentType: "application/json",
         data: JSON.stringify({ down_votes: "True" }),
         success: function (response) {
             loadPosts();
         },
         error: function (error) {
             alert('Failed to downvote');
         }
     });
  }

  function openPostModal() {
   const modal = $("#postModal");
   modal.css("display", "block");
   const contentInput = $("#contentInput");
   const titleInput = $("#titleInput");
   const addPostButton = $("#addPostButton");

   addPostButton.click(() => {
       const titleVal = titleInput.val();
       const contentVal = contentInput.val();
       if (titleVal && contentVal) {
         var headers = {
             "Accept": "application/json",
             "x-api-key": process.env.REACT_APP_API_POSTS_KEY
         };

         var apiEndpoint = process.env.REACT_APP_API_POSTS_INVOKE_URL;
         console.log('BioInquiry' + JSON.stringify(name));
         $.ajax({
             url: apiEndpoint,
             type: 'POST',
             headers: headers,
             contentType: "application/json",
             data: JSON.stringify({ title: titleVal,
             content: contentVal,
             uniqueuserid: uniqueUserId,
             username: name,
             useremail: email}),
             success: function (response) {
                 alert('Added Post successfully');
                 loadPosts();
             },
             error: function (error) {
                 alert('Failed to add post');
             }
           });

           addPostButton.prop("disabled", true);
           closePostModal();
       }
   });

   const closeButton = $(".close");
   closeButton.click(closePostModal);
  }

  function closePostModal() {
   const modal = $("#postModal");
   const postInput = $("#postInput");
   const createPostButton = $("#createPostButton");

   postInput.val("");
   createPostButton.prop("disabled", false);
   modal.css("display", "none");
  }

  return {loadPosts,displayPostsWithVotes,displayComments,formatTimestamp,openCommentModal,closeCommentModal,openPostModal,closePostModal,downvotePost,upvotePost};
  }
